import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
    FolderSocialAcquireProcessUpdateInput,
} from '@libs/types/src/services/input-type/folder/folder-social-acquire-process.update-input';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { FolderPrimaryDateLabelDialogStore } from './folder-primary-date-label-dialog.store';
import { TextInputComponent } from '../../../../kit/input/text-input/text-input.component';
import { AppFormGroup } from '../../../../../utils/form.utils';
import { fb, translate } from '../../../../../modules/shared/shared.global-service';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import {
    FolderSocialAcquireProcessObject,
} from '@libs/types/src/services/object-type/folder/folder-social-acquire-process.object';
import { socialAcquireProcessUpdateFrag } from './folder-primary-date-label-dialog.query';

@Component({
    selector: 'app-folder-primary-date-label-dialog',
    templateUrl: './folder-primary-date-label-dialog.component.html',
    styleUrl: './folder-primary-date-label-dialog.component.scss',
    providers: [FolderPrimaryDateLabelDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextInputComponent,
    ],
})
export class FolderPrimaryDateLabelDialogComponent extends BaseDialogComponent {

    public readonly store = inject(FolderPrimaryDateLabelDialogStore);

    protected form = new AppFormGroup({
        label: fb.control<string | null>(null),
    });

    protected acquireProcess: FolderSocialAcquireProcessObject;

    constructor() {
        super();

        this.acquireProcess = this.dialogConfig.data.acquireProcess;

        this.form.patchValue({ label: this.acquireProcess.primaryContactDateLabel || translate.instant('person.dashboard.importantInfo.primaryContactDate') });
    }

    public override async save(_event: Event) {
        await this.store.api.updateFolderSocialAcquireProcess({
            id: this.acquireProcess.id || 0,
            primaryContactDateLabel: this.form.value.label,
        } as FolderSocialAcquireProcessUpdateInput, socialAcquireProcessUpdateFrag);

        contentGlobalSuccess.next('common.updated');

        this.dialogRef.close();
    }

}
